import { l } from 'constants/common';
import { RoutesList } from 'routes';

const {
    ADMINISTRATION_SMS_PROVIDERS,
    SEGMENT_LIST,
    TEMPLATE_LIST,
    CAMPAIGN_LIST,
    REPORT_LIST,
    REALTIME_PROMOTIONS_LIST,
    CONFIGURATION_NOTIFICATIONS,
    CONFIGURATION,
    PREDEFINED_LIST,
    CONFIGURATION_EXCLUSION_RULES,
    CONFIGURATION_FORMULA_FILTER,
    CONFIGURATION_ACHIEVEMENT_LIST,
    ADMINISTRATION_KNOWLEDGE_CENTER_ARTICLES_LIST: ADMINISTRATION_KNOWLEDGE_CENTER_ARTICLES,
} = RoutesList;

const dynamicSegmentMetaData = {
    title: l.SaveDynamicSegment,
    pageName: l.SegmentList,
    route: SEGMENT_LIST,
};

const predefinedSegmentMetaData = {
    title: l.SaveDynamicSegment,
    pageName: l.PredefinedList,
    route: PREDEFINED_LIST,
};

const compositeSegmentMetaData = {
    title: l.SaveCompositeSegment,
    pageName: l.SegmentList,
    route: SEGMENT_LIST,
};

const staticSegmentMetaData = {
    title: l.SaveStaticSegment,
    pageName: l.SegmentList,
    route: SEGMENT_LIST,
};

const emailTemplateMetaData = {
    title: l.SaveEmailTemplete,
    pageName: l.TemplateList,
    route: TEMPLATE_LIST,
};

const predefinedEmailTemplateMetaData = {
    title: l.SavePredefinedEmailTemplate,
    pageName: l.PredefinedList,
    route: PREDEFINED_LIST,
};

const dynamicPopUpTemplateMetaData = {
    title: l.SaveDynamicPopUpTemplate,
    pageName: l.TemplateList,
    route: TEMPLATE_LIST,
};

const predefinedDynamicPopUpTemplateMetaData = {
    title: l.SavePredefinedDynamicPopUpTemplate,
    pageName: l.PredefinedList,
    route: PREDEFINED_LIST,
};

const smsTemplateMetaData = {
    title: l.SaveSMSTemplete,
    pageName: l.TemplateList,
    route: TEMPLATE_LIST,
};

const predefinedSmsTemplateMetaData = {
    title: l.SavePredefinedSMSTemplete,
    pageName: l.PredefinedList,
    route: PREDEFINED_LIST,
};

const hooryTemplateMetaData = {
    title: l.SaveHooryTemplate,
    pageName: l.TemplateList,
    route: TEMPLATE_LIST,
};

const internalMessageTemplateMetaData = {
    title: l.SaveInternalMessageTemplete,
    pageName: l.TemplateList,
    route: TEMPLATE_LIST,
};

const predefinedInternalMessageTemplateMetaData = {
    title: l.SavePredefinedInternalMessageTemplate,
    pageName: l.PredefinedList,
    route: PREDEFINED_LIST,
};

const telegramTemplateMetaData = {
    title: l.SaveTelegramTemplete,
    pageName: l.TemplateList,
    route: TEMPLATE_LIST,
};

const predefinedTelegramTemplateMetaData = {
    title: l.SavePredefinedTelegramTemplate,
    pageName: l.PredefinedList,
    route: PREDEFINED_LIST,
};

const campaignMetaData = {
    title: l.SaveCampaign,
    pageName: l.CampaignList,
    route: CAMPAIGN_LIST,
};

const customerJourneyMetaData = {
    title: l.SaveCustomerJourney,
    pageName: l.RealtimePromotionsList,
    route: REALTIME_PROMOTIONS_LIST,
};

const predefinedCustomerJourneyMetaData = {
    title: l.SavePredefinedCustomerJourney,
    pageName: l.PredefinedList,
    route: PREDEFINED_LIST,
};

const reportMetaData = {
    title: l.SaveReport,
    pageName: l.ReportList,
    route: REPORT_LIST,
};

const predefinedReportMetaData = {
    title: l.SavePredefinedReport,
    pageName: l.PredefinedList,
    route: PREDEFINED_LIST,
};

const reportExecuteMetaData = {
    title: l.ExecuteReport,
    pageName: l.ReportList,
    route: REPORT_LIST,
};

const reportScheduleMetaData = {
    title: l.ScheduleReport,
    pageName: l.ReportList,
    route: REPORT_LIST,
};

const pushNotificationTemplateMetaData = {
    title: l.SavePushNotificationTemplate,
    pageName: l.TemplateList,
    route: TEMPLATE_LIST,
};

const predefinedPushNotificationTemplateMetaData = {
    title: l.SavePredefinedPushNotificationTemplate,
    pageName: l.PredefinedList,
    route: PREDEFINED_LIST,
};

const customerJourneyVisualizationMetaData = {
    title: l.SaveCustomerJourneyVisualization,
    pageName: l.RealtimePromotionsList,
    route: REALTIME_PROMOTIONS_LIST,
};

const popUpNotificationTemplateMetaData = {
    title: l.SavePopUpNotificationTemplate,
    pageName: l.TemplateList,
    route: TEMPLATE_LIST,
};

const cmsPopUpNotificationTemplateMetaData = {
    title: l.SaveCMSPopUpNotificationTemplate,
    pageName: l.TemplateList,
    route: TEMPLATE_LIST,
};

const NotificationCampaign = {
    title: l.SaveNotification,
    pageName: l.NotificationsList,
    route: CONFIGURATION_NOTIFICATIONS,
};

const templateLanguages = {
    title: l.TemplateLanguages,
    pageName: l.TemplateLanguages,
    route: CONFIGURATION,
};

const compositeReportMetaData = {
    title: l.SaveCompositeReport,
    pageName: l.ReportList,
    route: REPORT_LIST,
};

const customerJourneyReportMetaData = {
    title: l.SaveCustomerJourneyReport,
    pageName: l.ReportList,
    route: REPORT_LIST,
};

const viberTemplateMetaData = {
    title: l.SaveViberTemplate,
    pageName: l.TemplateList,
    route: TEMPLATE_LIST,
};

const whatsAppTemplateMetaData = {
    title: l.SaveWhatsAppTemplate,
    pageName: l.TemplateList,
    route: TEMPLATE_LIST,
};

const whatsAppProviderTemplateMetaData = {
    title: l.SaveWhatsAppProviderTemplate,
    pageName: l.TemplateList,
    route: TEMPLATE_LIST,
};

const cmsBannerTemplateMetaData = {
    title: l.SaveCMSBannerTemplate,
    pageName: l.TemplateList,
    route: TEMPLATE_LIST,
};

const predefinedViberTemplateMetaData = {
    title: l.SavePredefinedViberTemplate,
    pageName: l.PredefinedList,
    route: PREDEFINED_LIST,
};

const predefinedHooryTemplateMetaData = {
    title: l.SavePredefinedHooryTemplate,
    pageName: l.PredefinedList,
    route: PREDEFINED_LIST,
};

const predefinedWhatsAppProviderTemplateMetaData = {
    title: l.SavePredefinedWhatsAppProviderTemplate,
    pageName: l.PredefinedList,
    route: PREDEFINED_LIST,
};

const realtimeActionCampaignMetaData = {
    title: l.SaveRealtimeActionCampaign,
    pageName: l.RealtimePromotionsList,
    route: REALTIME_PROMOTIONS_LIST,
};

const predefinedRealtimeActionCampaignMetaData = {
    title: l.SavePredefinedRealtimeActionCampaign,
    pageName: l.PredefinedList,
    route: PREDEFINED_LIST,
};

const createSMSProviderMetaData = {
    title: l.CreateSMSProvider,
    pageName: l.SMSProvidersList,
    route: ADMINISTRATION_SMS_PROVIDERS,
};
const editSMSProviderMetaData = {
    title: l.EditSMSProvider,
    pageName: l.SMSProvidersList,
    route: ADMINISTRATION_SMS_PROVIDERS,
};
const cloneSMSProviderMetaData = {
    title: l.CloneSMSProvider,
    pageName: l.SMSProvidersList,
    route: ADMINISTRATION_SMS_PROVIDERS,
};

const exclusionRulesMetaData = {
    title: l.ExclusionRulesManagementCreate,
    pageName: l.ExclusionRulesManagement,
    route: CONFIGURATION_EXCLUSION_RULES,
};

const formulaFiltersMetaData = {
    title: l.SaveFormulaFilter,
    pageName: l.FormulaFilters,
    route: CONFIGURATION_FORMULA_FILTER,
};

const achievementMetaData = {
    title: l.SaveAchievement,
    pageName: l.AchievementList,
    route: CONFIGURATION_ACHIEVEMENT_LIST,
};

const knowledgeCenterArticleMetaData = {
    title: l.SaveArticle,
    pageName: l.KnowledgeCenterArticles,
    route: ADMINISTRATION_KNOWLEDGE_CENTER_ARTICLES,
};

const redirectMetaData = {
    CreateDynamicSegment: dynamicSegmentMetaData,
    CloneDynamicSegment: dynamicSegmentMetaData,
    EditDynamicSegment: dynamicSegmentMetaData,
    CreateStaticSegment: staticSegmentMetaData,
    CreateCompositeSegment: compositeSegmentMetaData,
    CloneCompositeSegment: compositeSegmentMetaData,
    EditCompositeSegment: compositeSegmentMetaData,
    CreateNonCustomerSegment: staticSegmentMetaData,
    CreateEmailTemplate: emailTemplateMetaData,
    CloneEmailTemplate: emailTemplateMetaData,
    EditEmailTemplate: emailTemplateMetaData,
    CreateDynamicPopUpTemplate: dynamicPopUpTemplateMetaData,
    CloneDynamicPopUpTemplate: dynamicPopUpTemplateMetaData,
    EditDynamicPopUpTemplate: dynamicPopUpTemplateMetaData,
    CreateSMSTemplate: smsTemplateMetaData,
    CloneSMSTemplate: smsTemplateMetaData,
    EditSMSTemplate: smsTemplateMetaData,
    CreateHooryTemplate: hooryTemplateMetaData,
    CloneHooryTemplate: hooryTemplateMetaData,
    EditHooryTemplate: hooryTemplateMetaData,
    CreateInternalMessageTemplate: internalMessageTemplateMetaData,
    CloneInternalMessageTemplate: internalMessageTemplateMetaData,
    EditInternalMessageTemplate: internalMessageTemplateMetaData,
    CreateTelegramTemplate: telegramTemplateMetaData,
    CloneTelegramTemplate: telegramTemplateMetaData,
    EditTelegramTemplate: telegramTemplateMetaData,
    CreateCampaign: campaignMetaData,
    EditCampaign: campaignMetaData,
    CloneCampaign: campaignMetaData,
    CreateCustomerJourney: customerJourneyMetaData,
    EditCustomerJourney: customerJourneyMetaData,
    CloneCustomerJourney: customerJourneyMetaData,
    CreateReport: reportMetaData,
    EditReport: reportMetaData,
    CloneReport: reportMetaData,
    CreateReportFromSegment: reportMetaData,
    CreatePushNotificationTemplate: pushNotificationTemplateMetaData,
    ClonePushNotificationTemplate: pushNotificationTemplateMetaData,
    EditPushNotificationTemplate: pushNotificationTemplateMetaData,
    CreateCustomerJourneyVisualization: customerJourneyVisualizationMetaData,
    EditCustomerJourneyVisualization: customerJourneyVisualizationMetaData,
    CreatePopUpNotificationTemplate: popUpNotificationTemplateMetaData,
    EditPopUpNotificationTemplate: popUpNotificationTemplateMetaData,
    ClonePopUpNotificationTemplate: popUpNotificationTemplateMetaData,
    CreateCMSPopUpNotificationTemplate: cmsPopUpNotificationTemplateMetaData,
    EditCMSPopUpNotificationTemplate: cmsPopUpNotificationTemplateMetaData,
    CloneCMSPopUpNotificationTemplate: cmsPopUpNotificationTemplateMetaData,
    NotificationCampaign: NotificationCampaign,
    ScheduleReport: reportScheduleMetaData,
    ExecuteReport: reportExecuteMetaData,
    CreateCompositeReport: compositeReportMetaData,
    CloneCompositeReport: compositeReportMetaData,
    EditCompositeReport: compositeReportMetaData,
    CreateCustomerJourneyReport: customerJourneyReportMetaData,
    EditCustomerJourneyReport: customerJourneyReportMetaData,
    CloneCustomerJourneyReport: customerJourneyReportMetaData,
    CreateViberTemplate: viberTemplateMetaData,
    EditViberTemplate: viberTemplateMetaData,
    CloneViberTemplate: viberTemplateMetaData,
    CreateWhatsAppTemplate: whatsAppTemplateMetaData,
    EditWhatsAppTemplate: whatsAppTemplateMetaData,
    CloneWhatsAppTemplate: whatsAppTemplateMetaData,
    CreateWhatsAppProviderTemplate: whatsAppProviderTemplateMetaData,
    EditWhatsAppProviderTemplate: whatsAppProviderTemplateMetaData,
    CloneWhatsAppProviderTemplate: whatsAppProviderTemplateMetaData,
    CreateCMSBannerTemplate: cmsBannerTemplateMetaData,
    EditCMSBannerTemplate: cmsBannerTemplateMetaData,
    CloneCMSBannerTemplate: cmsBannerTemplateMetaData,
    TemplateLanguages: templateLanguages,
    CreateActionCampaign: realtimeActionCampaignMetaData,
    EditActionCampaign: realtimeActionCampaignMetaData,
    CloneActionCampaign: realtimeActionCampaignMetaData,
    [l.CreateSMSProvider]: createSMSProviderMetaData,
    [l.EditSMSProvider]: editSMSProviderMetaData,
    [l.CloneSMSProvider]: cloneSMSProviderMetaData,
    [l.CreatePredefinedDynamicSegment]: predefinedSegmentMetaData,
    [l.EditPredefinedDynamicSegment]: predefinedSegmentMetaData,
    [l.ClonePredefinedSegment]: predefinedSegmentMetaData,
    [l.CreatePredefinedEmailTemplate]: predefinedEmailTemplateMetaData,
    [l.EditPredefinedEmailTemplate]: predefinedEmailTemplateMetaData,
    [l.ClonePredefinedEmailTemplate]: predefinedEmailTemplateMetaData,
    [l.CreatePredefinedDynamicPopUpTemplate]: predefinedDynamicPopUpTemplateMetaData,
    [l.EditPredefinedDynamicPopUpTemplate]: predefinedDynamicPopUpTemplateMetaData,
    [l.ClonePredefinedDynamicPopUpTemplate]: predefinedDynamicPopUpTemplateMetaData,
    [l.CreatePredefinedSMSTemplate]: predefinedSmsTemplateMetaData,
    [l.EditPredefinedSMSTemplate]: predefinedSmsTemplateMetaData,
    [l.ClonePredefinedSMSTemplate]: predefinedSmsTemplateMetaData,
    [l.CreatePredefinedInternalMessageTemplate]: predefinedInternalMessageTemplateMetaData,
    [l.EditPredefinedInternalMessageTemplate]: predefinedInternalMessageTemplateMetaData,
    [l.ClonePredefinedInternalMessageTemplate]: predefinedInternalMessageTemplateMetaData,
    [l.CreatePredefinedTelegramTemplate]: predefinedTelegramTemplateMetaData,
    [l.EditPredefinedTelegramTemplate]: predefinedTelegramTemplateMetaData,
    [l.ClonePredefinedTelegramTemplate]: predefinedTelegramTemplateMetaData,
    [l.CreatePredefinedCustomerJourney]: predefinedCustomerJourneyMetaData,
    [l.EditPredefinedCustomerJourney]: predefinedCustomerJourneyMetaData,
    [l.ClonePredefinedCustomerJourney]: predefinedCustomerJourneyMetaData,
    [l.CreatePredefinedReport]: predefinedReportMetaData,
    [l.EditPredefinedReport]: predefinedReportMetaData,
    [l.ClonePredefinedReport]: predefinedReportMetaData,
    [l.CreatePredefinedPushNotificationTemplate]: predefinedPushNotificationTemplateMetaData,
    [l.EditPredefinedPushNotificationTemplate]: predefinedPushNotificationTemplateMetaData,
    [l.ClonePredefinedPushNotificationTemplate]: predefinedPushNotificationTemplateMetaData,
    [l.CreatePredefinedViberTemplate]: predefinedViberTemplateMetaData,
    [l.EditPredefinedViberTemplate]: predefinedViberTemplateMetaData,
    [l.ClonePredefinedViberTemplate]: predefinedViberTemplateMetaData,
    [l.CreatePredefinedHooryTemplate]: predefinedHooryTemplateMetaData,
    [l.EditPredefinedHooryTemplate]: predefinedHooryTemplateMetaData,
    [l.ClonePredefinedHooryTemplate]: predefinedHooryTemplateMetaData,
    [l.CreatePredefinedWhatsAppProviderTemplate]: predefinedWhatsAppProviderTemplateMetaData,
    [l.EditPredefinedWhatsAppProviderTemplate]: predefinedWhatsAppProviderTemplateMetaData,
    [l.ClonePredefinedWhatsAppProviderTemplate]: predefinedWhatsAppProviderTemplateMetaData,
    [l.CreatePredefinedActionCampaign]: predefinedRealtimeActionCampaignMetaData,
    [l.EditPredefinedActionCampaign]: predefinedRealtimeActionCampaignMetaData,
    [l.ClonePredefinedActionCampaign]: predefinedRealtimeActionCampaignMetaData,
    [l.ExclusionRulesManagementCreate]: exclusionRulesMetaData,
    [l.ExclusionRulesManagementEdit]: exclusionRulesMetaData,
    [l.CreateFormulaFilter]: formulaFiltersMetaData,
    [l.EditFormulaFilter]: formulaFiltersMetaData,
    [l.CloneFormulaFilter]: formulaFiltersMetaData,
    [l.CreateAchievement]: achievementMetaData,
    [l.CloneAchievement]: achievementMetaData,
    [l.EditAchievement]: achievementMetaData,
    [l.CreateArticle]: knowledgeCenterArticleMetaData,
    [l.CloneArticle]: knowledgeCenterArticleMetaData,
    [l.EditArticle]: knowledgeCenterArticleMetaData,
};

export { redirectMetaData };
